module.exports = __webpack_public_path__ + "static/media/easy-restaurante.75dd1f7d.png";